import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type DeleteCampaignFailureModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function DeleteCampaignFailureModal({ isOpen, handleClose }: DeleteCampaignFailureModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="delete-campaign-failure">
      <AcknowledgeModal
        result="negative"
        title={t('typography.givingCampaigns.deleteCampaign.failure.title')}
        description={t('errorMessage.genericError')}
        buttonText={t('button.close')}
        handleClose={handleClose}
      />
    </Modal>
  )
}
